export default {
    methods: {
        onModalHidden() {
            this.$emit('modal-hidden');
        },

        onModalShown() {},

        showModal() {
            $(this.$el)
                .on('shown.bs.modal', e => {
                    this.$emit('modal-shown');
                    this.onModalShown();
                })
                .modal('show');
        },

        hideModal() {
            $(this.$el).modal('hide');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/modals.js